export const LOGIN_URI = process.env.REACT_APP_LOGIN_URI || "";
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || "";
export const API_URI = process.env.REACT_APP_API_URI || "";
